import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { useHistory, useLocation } from 'react-router-dom';
import {
  Box,
  Typography,
  Link as MuiLink,
} from '@material-ui/core';
import DialogTemplate from 'components/shared/DialogTemplate';
import {
  userData as userDataSelector,
} from 'selectors/user';
import * as cottageSelectors from 'selectors/cottage';
import CompoundIDVerification from 'modules/users/containers/CompoundIDVerification';
import { PayoutContainer } from 'modules/users/containers/Payout';

const VerifyDialog = ({
  isLoading,
  onClose,
  onVerify,
}) => {
  const location = useLocation();
  const history = useHistory();
  const [verified, setVerified] = React.useState(false);
  const [showPayoutFlow, setShowPayoutFlow] = React.useState(false);
  const user = useSelector(userDataSelector);
  const cottage = useSelector(cottageSelectors.data);
  const isVerified = cottage && (cottage.verified_by === 'BOTH' || cottage.verified_by === 'BANKID');

  React.useEffect(() => {
    if (location?.state?.step || location?.search?.includes('payout')) {
      setShowPayoutFlow(true);
    }
  }, []);

  React.useEffect(() => {
    if (!user || !cottage) {
      return;
    }

    if (!isLoading && !verified) {
      if (user.bankid_verified_at && user.bankid_session) {
        setVerified(true);
        return onVerify();
      }

      if (!user.bankid_verified_at && ['SUCCEDED', 'PENDING'].includes(user.kyc_status) && !cottage.verified_at) {
        setVerified(true);
        return onVerify();
      }
    }
  }, [user, cottage]);

  const setPayoutFlow = () => {
    setShowPayoutFlow(true);
    const payoutTab = `${location.pathname}?payout=verify`;
    history.replace(payoutTab, { step: true });
  };

  if (isLoading || isVerified) {
    return null;
  }

  return (
    <DialogTemplate
      title={(
        <FormattedMessage
          id="Verify your identity"
          defaultMessage="Verify your identity"
        />
      )}
      isNew={false}
      onClose={onClose}
      onSave={null}
      isUpdating={isLoading}
    >
      <Box p={2}>
        {
          !showPayoutFlow && (
            <>
              <CompoundIDVerification showBankIDLogin verificationMethods={['BANKID']} />
            </>
          )
        }
        {
          !showPayoutFlow && user.booking_valid && (
            <>
              <Box textAlign="center">
                <Typography variant="body2">
                  <FormattedMessage
                    id="verification.expand"
                    defaultMessage="If you do not have BankID"
                  />&nbsp;
                  <MuiLink onClick={() => setPayoutFlow()}>
                    <FormattedMessage id="click here" defaultMessage="click here" />
                  </MuiLink>
                </Typography>
              </Box>
            </>
          )
        }
        {
          showPayoutFlow && (
            <>
              <PayoutContainer requiredIban={false} disablePromptBankidLogin />
            </>
          )
        }

      </Box>
    </DialogTemplate>
  );
};

VerifyDialog.propTypes = {
  isLoading: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onVerify: PropTypes.func.isRequired,
};

export default VerifyDialog;
